import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./Card.module.scss";

interface CardProps {
  icon?: string;
  title: string;
  description?: string;
  translateTitle?: boolean;
  translateDescription?: boolean;
}

const Card: React.FC<CardProps> = ({
  icon,
  title,
  description,
  translateTitle = false,
  translateDescription = false,
}) => {
  const { t } = useTranslation("common");

  const titleClass =
    icon || description ? styles.cardTitle : styles.cardTitleWithNoContent;

  const displayTitle = translateTitle ? t(title) : title;
  const displayDescription = description
    ? translateDescription
      ? t(description)
      : description
    : undefined;

  return (
    <div className={styles.card}>
      {icon && (
        <img src={icon} alt={displayTitle} className={styles.cardIcon} />
      )}
      <h3
        className={titleClass}
        dangerouslySetInnerHTML={{
          __html: displayTitle,
        }}
      />
      {displayDescription && (
        <p className={styles.cardDescription}>{displayDescription}</p>
      )}
    </div>
  );
};

export default Card;
